import { apiClient } from "../../base/ApiClient";

export const createMedication = async (formData) => {
  const response = await apiClient.post(`/services/medicines/`, formData);
  return response;
};

export const getMedications = async (clientID, page) => {
  const response = await apiClient.get(
    `/services/${clientID}/medicines/?page=${page ? page : ""}`
  );
  return response.data;
};
export const getAllClientMedications = async (clientID) => {
  const response = await apiClient.get(`/services/${clientID}/medicines/`);
  return response.data;
};

export const getMedication = async (medicationId) => {
  const response = await apiClient.get(`/services/medicines/${medicationId}/`);
  return response.data;
};

export const deleteMedication = async (medicationId) => {
  const response = await apiClient.delete(
    `/services/medicines/${medicationId}/`
  );
  return response;
};

export const updateMedication = async (medicationId, formData) => {
  const response = await apiClient.put(
    `/services/medicines/${medicationId}/`,
    formData
  );
  return response;
};

export const getMedicineByVisit = async (visitId) => {
  const response = await apiClient.get(
    `/services/visits/${visitId}/medicines/`
  );
  return response.data;
};

export const getMedicationEvents = async (clientID, month) => {
  const response = await apiClient.get(
    `/services/medication-events/?client_id=${clientID}&month=${month}`
  );
  return response.data;
};

export const getMedicineNames = async (search) => {
  const response = await apiClient.get(
    `/services/medicine-names/?search=${search ? search : ""}&page=1`
  );
  return response.data;
};

export const getMedicineList = async (page) => {
  const response = await apiClient.get(`/services/medicine-name/?page=${page}`);
  return response.data;
};

export const addMedicine = async (formdata) => {
  const response = await apiClient.post(`/services/medicine-name/`, formdata);
  return response;
};
export const editMedicine = async (id, formdata) => {
  const response = await apiClient.put(
    `/services/medicine-name/${id}/`,
    formdata
  );
  return response;
};
export const deleteMedicine = async (id) => {
  const response = await apiClient.delete(`/services/medicine-name/${id}/`);
  return response;
};

export const refillMedication = async (medId, formData) => {
  const response = await apiClient.patch(
    `/services/medication-refill/?medicine=${medId}`,
    formData
  );
  return response.data;
};

export const getMedicationRefillHistory = async (medId) => {
  const response = await apiClient.get(
    `/services/medication-refill/?medicine=${medId}`
  );
  return response.data;
};

export const adjustMedicationStock = async (medicineId, payload) => {
  const response = await apiClient.post(
    `/services/medicines/${medicineId}/adjust-stock/`,
    payload
  );
  return response.data;
};